"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _BaseColumn = require("./support/BaseColumn");
var _ColumnUtils = require("./support/ColumnUtils");
var GroupingColumn = function GroupingColumn(_) {
  return null;
};
var ID = 'grouping-column';
GroupingColumn.toColumnDefs = function (child, intl, grouping) {
  var _child$props = child.props,
    defaultColumnKey = _child$props.defaultColumnKey,
    children = _child$props.children,
    _footer = _child$props.footer;
  var childColumns = _react.default.Children.map(children, function (child) {
    return (child === null || child === void 0 ? void 0 : child.type) === _react.Fragment ? child.props.children : child;
  }).filter(Boolean);
  var keys = childColumns.map(function (columnChild) {
    return columnChild.props.id || (0, _ColumnUtils.accessKeyToId)(columnChild.props.accessorKey);
  });
  var getSortingValue = function getSortingValue(rowA, key) {
    var value = rowA.getValue(key);
    if (value instanceof Date) {
      value = value.toISOString();
    }
    return value;
  };
  var getDefaultColumnId = function getDefaultColumnId(row) {
    return (0, _ColumnUtils.accessKeyToId)(typeof defaultColumnKey === 'string' ? defaultColumnKey : defaultColumnKey(row.original));
  };
  var columnDefs = [_objectSpread({}, (0, _BaseColumn.defaultColumnDef)(child.props, undefined, true), {
    id: ID,
    accessorFn: function accessorFn(originalRow) {
      return keys.map(function (key) {
        return originalRow[key];
      }).join(' ');
    },
    sortingFn: function sortingFn(rowA, rowB) {
      var rowADefaultColumnID = getDefaultColumnId(rowA);
      var rowBDefaultColumnID = getDefaultColumnId(rowB);
      var defaultColumnValueA = rowA.getValue(rowADefaultColumnID);
      var defaultColumnValueB = rowB.getValue(rowBDefaultColumnID);
      var rowASortValue = grouping.map(function (key) {
        return getSortingValue(rowA, key);
      }).join(' ');
      var rowBSortValue = grouping.map(function (key) {
        return getSortingValue(rowB, key);
      }).join(' ');
      rowASortValue = rowASortValue + ' ' + defaultColumnValueA;
      rowBSortValue = rowBSortValue + ' ' + defaultColumnValueB;
      return rowASortValue.localeCompare(rowBSortValue);
    },
    cell: function cell(props) {
      var table = props.table,
        row = props.row;
      var currentColumnId;
      if (row.getIsGrouped() && row.groupingColumnId) {
        currentColumnId = row.groupingColumnId;
      } else {
        currentColumnId = getDefaultColumnId(row);
      }
      var currentColumn = table.getColumn(currentColumnId);
      if (currentColumn && currentColumn.columnDef.cell) {
        if (typeof currentColumn.columnDef.cell === 'string') {
          return currentColumn.columnDef.cell;
        } else {
          return currentColumn.columnDef.cell(_objectSpread({}, props, {
            column: currentColumn,
            getValue: function getValue() {
              return row.getValue(currentColumnId);
            }
          }));
        }
      }
      console.error('Could not find column cell to render');
      return null;
    },
    footer: function footer() {
      if (_footer !== undefined) {
        return (0, _BaseColumn.styledCell)(child.props, _footer);
      }
      return null;
    }
  })];
  childColumns.forEach(function (columnChild) {
    var columnDef = columnChild.type.toColumnDef(columnChild, intl);
    columnDef.meta.visible = false;
    columnDefs.push(columnDef);
  });
  return columnDefs;
};
GroupingColumn.ID = ID;
var _default = exports.default = GroupingColumn;